import { AppAwareHtml } from "@/components/r3f/renderers/app-aware-html";
import { ANNOTATION_ZINDEX_RANGE_MAP } from "@/components/ui/annotations/annotation-zindex-range-map";
import { ImageType } from "@/components/ui/tree/tree-context-menu/actions/upload-action";
import { MapPlaceholderDefaultIcon } from "@faro-lotv/flat-ui";
import { Box } from "@mui/system";
import { MutableRefObject, type JSX } from "react";
import { ReactComponent as Img2dIcon } from "../../../../components/ui/icons/2Dphoto-selected.svg";
import { NewWaypoint } from "./new-waypoints-store";

type NewWaypointIconProps = {
  newWaypoint: NewWaypoint;

  parentRef: MutableRefObject<HTMLElement>;
};

/** @returns a label displaying an uploading waypoint indicator. */
export function NewWaypointIcon({
  newWaypoint,
  parentRef,
}: NewWaypointIconProps): JSX.Element {
  return (
    <AppAwareHtml
      portal={parentRef}
      position={newWaypoint.worldPosition}
      zIndexRange={ANNOTATION_ZINDEX_RANGE_MAP.toolbar}
      eps={-1}
      style={{
        pointerEvents: "none",
      }}
    >
      <Box
        component="div"
        sx={{ transform: "translate(-50%, -50%) scale(0.9)" }}
      >
        {newWaypoint.type === ImageType.Img2D ? (
          <Img2dIcon />
        ) : (
          <MapPlaceholderDefaultIcon />
        )}
      </Box>
    </AppAwareHtml>
  );
}
